import React from "react";
import { CancelButton, ConfirmButton, FooterContainer } from "../../styles";
import { useAppTranslation } from "../../../locales/translate";

interface Props {
  onConfirm: () => void;
  onCancel: () => void;
  deleteDisabled: boolean;
}

export const DeleteFooter = ({
  onConfirm,
  onCancel,
  deleteDisabled,
}: Props) => {
  const { t } = useAppTranslation();

  return (
    <FooterContainer>
      <ConfirmButton negative onClick={onConfirm} disabled={deleteDisabled}>
        {t("DELETE_MODAL_CONFIRM_BUTTON_TEXT")}
      </ConfirmButton>
      <CancelButton link onClick={onCancel}>
        {t("CANCEL_BUTTON_TEXT")}
      </CancelButton>
    </FooterContainer>
  );
};
